import axios from 'axios'

export const marketing_service = {

  async save_marketing(data) {
    return axios.post(`save-marketing`, data)
  },
}